module.exports = __webpack_public_path__ + "media/images/clear-plus-83011b85d6f11e2cfb8d2c8724594b73.svg";